import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

// * Background color wrapper
export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

// * Grid
export const StyledContainer = styled(Container)`
  padding: 110px 0 60px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 110px 45px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    /* padding: 100px 90px 90px; */
    padding: 70px 0 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    /* padding: 100px 90px 90px; */
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    /* padding: 100px 90px 90px; */
    padding: 70px 90px 90px;
  }
`;

// * Body Wrapper (holds the headings, and paragraphs)
export const Intro = styled.div`
  margin-bottom: 40px;

  h1,
  h2,
  h3,
  h4 {
    position: relative;

    margin-bottom: 20px;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -47px;
      background-image: url(${({ imageLogo }) => imageLogo});
      height: 37px;
      width: 116px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    align-items: center;
    // justify-content: space-between;

    margin-bottom: 85px;

    h1,
    h2,
    h3,
    h4 {
      font-size: 48px;
      letter-spacing: -0.32px;
      line-height: 58px;
      margin-bottom: 0;
      max-width: calc(50% - 30px);

      &::before {
        top: -67px;
        height: 37px;
        width: 116px;
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 349.89px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: auto;
    width: 100%;
    max-width: 251px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 50%;
    max-width: 501.3px;

    margin-left: 60px;
  }
`;

// * Large image beside FAQ title
export const FAQImg = styled(Image)`
  width: 100%;

  object-fit: contain;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

// * Wrapper for all FAQs
export const Questions = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
  }
`;

// * Each FAQ question
export const Faq = styled.div`
  padding: 24px 0 40px;

  border-top: 1px solid #979797;

  &:last-child {
    padding-bottom: 0;
  }

  h2,
  h3,
  h4 {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 24px 0 60px;
    flex: 0 1 calc(50% - 30px);

    border-bottom: 1px solid #979797;

    h2,
    h3,
    h4 {
      margin-bottom: 20px;
    }

    // * FAQ on the left of every row
    &:nth-child(odd) {
      margin-right: 30px;
    }

    // * FAQ on the right of every row
    &:nth-child(even) {
      margin-left: 30px;
    }

    // * First two FAQs
    &:nth-child(2),
    &:first-child {
      border-top: 1px solid #979797;
    }

    // * Last two FAQs
    &:nth-last-child(2),
    &:last-child {
      border-bottom: 0;
      padding-bottom: 60px;
    }
  }
`;
